import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainIdentificationSection } from './components/PainIdentificationSection';
import { NewMechanismSection } from './components/NewMechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductContentSection } from './components/ProductContentSection';
import { TransformationSection } from './components/TransformationSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { PricingSection } from './components/PricingSection';
import { EmotionalClosingSection } from './components/EmotionalClosingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainIdentificationSection data-id="element-2" />
      <NewMechanismSection data-id="element-3" />
      <PricingSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <ProductContentSection data-id="element-6" />
      <TransformationSection data-id="element-7" />
      <ObjectionsSection data-id="element-8" />
      <EmotionalClosingSection data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}